export let UpgradeMessageEventKeys;
(function (UpgradeMessageEventKeys) {
  UpgradeMessageEventKeys["OPEN_UPGRADE_PAGE"] = "__ui_addon_upgrades_OPEN_UPGRADE_PAGE";
  UpgradeMessageEventKeys["FETCH_UPGRADE_POINT"] = "__ui_addon_upgrades_FETCH_UPGRADE_POINT";
})(UpgradeMessageEventKeys || (UpgradeMessageEventKeys = {}));